import React from "react";
import { useStore } from "../../store/store";
import { SelectChangeEvent } from "@mui/material";
import { configImg } from "./FPConfigurationAccordian";

interface UpdateObj {
  exactConfig: string;
  sillStyle: string;
  jamb: string;
  exactConfigImg?: string;
}

function useConfigSelector() {
  const addToQuote = useStore((state) => state.addToQuote);
  const exactConfig = useStore((state) => state.quote.exactConfig);
  const stileCategory = useStore((state) => state.quote.stileCategory);

  const handleError = useStore((state) => state.handleError);
  const material = useStore((state) => state.quote.material);

  const isAluminum = material === "All Aluminum";

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const { value } = event.target;
    let update: UpdateObj = {
      exactConfig: value as string,
      sillStyle: "",
      jamb: "",
    };

    if (value) {
      const url = configImg.find((itm) => itm.type === value)?.url;
      update["exactConfigImg"] = url;
    }

    const picoShown = ["Fixed Bi-fold", "Fixed Full Bound"];

    if(stileCategory === "Pico" && !picoShown.includes(value as string)){
      update["stileCategory"] = ""
      update["stilesAndRails"] = ""
    }

    addToQuote(update);
    handleError("configErr", "")
  };

  return {
    handleChange,
    exactConfig,
    isAluminum
  };
}

export default useConfigSelector;
